import type { OrderCustomer } from "@/api/customer/_models/Customer";
import { toTitleCase } from "@/app/text.utils";

/** A customer the filter can pick: keyed by id (names can repeat), shown by name. */
export interface OrderListFilterCustomer {
  id: string;
  name: string;
}

/** Customers with orders as filter options, sorted by Title Case name; one without a name shows as its id. */
export const toOrderListFilterCustomerList = (customers: OrderCustomer[]): OrderListFilterCustomer[] => {
  return customers
    .map((customer) => {
      let name = customer.id;
      if (customer.name) name = toTitleCase(customer.name);
      return { id: customer.id, name };
    })
    .sort((a, b) => a.name.localeCompare(b.name));
};
